import styled from 'styled-components';
import { rem } from 'polished';
import { MaintenanceTemplate } from './MaintenanceTemplate';

export const MaintenanceStyled = styled(MaintenanceTemplate)`
    
`;
